<template>
    <div v-if="isLoaded">
        <BoxPaciente
            ref="BoxPaciente"
            :data="{ form, model }"
        />

        <rkm-tabs
            v-model="tabIndex"
        >
            <rkm-tab
                active
                title="Dispensação"
            >
                <TabDispensacao
                    ref="TabDispensacao"
                    :form="form"
                    :model="model"
                    :is-pendente="isPendente"
                    @save="handleSave()"
                />
            </rkm-tab>

            <rkm-tab
                :title="`Medicamentos pendentes (${getTotalMedicamentosPendentes})`"
            >
                <TabMedicamentosPendentes
                    ref="TabMedicamentosPendentes"
                    :items="form.receitasPendentes"
                    :totalMedicamentosPendentes="getTotalMedicamentosPendentes"
                    @dispensar="handleDispensar"
                />
            </rkm-tab>

            <rkm-tab
                title="Histórico de medicamentos"
            >
                <TabHistoricoMedicamento
                    ref="TabHistoricoMedicamento"
                    :form="form"
                />
            </rkm-tab>

            <rkm-tab
                title="Medicamento não padronizado"
            >
                <TabMedicamentoNaoPadronizado
                    ref="TabMedicamentoNaoPadronizado"
                    :form="form"
                    :model="model"
                />
            </rkm-tab>
        </rkm-tabs>

        <ModalPermissao
            ref="ModalPermissao"
            @handleSupervisorDispensar="handleSupervisorDispensar"
        />
    </div>
</template>

<script>
// Components
import BoxPaciente from '@/components/farmacia/paciente/Index'
import TabDispensacao from './tabs/Dispensacao'
import TabHistoricoMedicamento from './tabs/HistoricoMedicamentos'
import TabMedicamentoNaoPadronizado from './tabs/MedicamentoNaoPadronizado'
import TabMedicamentosPendentes from './tabs/MedicamentosPendentes'
import ModalPermissao from '@/components/farmacia/dispensacao/ModalPermissao'

// Mixins
import { repository, object, error, stringCase, data, request, printFarmacia, file } from '@/mixins'

//Moment
import moment from 'moment'

import { mapActions } from 'vuex'

import functions from '@/utils/farmacia/functions'
import utilGeral from '@/utils/geral'

export default {
    components: {
        BoxPaciente,
        TabDispensacao,
        TabHistoricoMedicamento,
        TabMedicamentoNaoPadronizado,
        TabMedicamentosPendentes,
        ModalPermissao
    },
    computed: {
        getTotalMedicamentosPendentes() {

            let total = 0

            this.form.receitasPendentes.map(receita => {

                total += receita.items.filter(item => !item.deleted).length
            })

            return total;
        }
    },
    created() {

        this.repositories = {
            paciente: this.getConectaSusRepository('cadastro.sujeitoAtencao.paciente'),
            dispensacao: this.getConectaSusRepository('farmacia.dispensacao'),
            impressao: this.getConectaSusRepository('impressao.farmacia'),
        }

        this.load()
    },
    data: () => ({
        additionals: null,
        tabIndex: 0,
        tabRefs: [],
        isLoaded: false,
        form: null,
        model: null,
        pacienteObservacao: null,
        justSave: true,
        pacienteChange: false,
        isPendente: false,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading', 'unsetShowExitFormConfirmation']),
        ...functions,
        ...utilGeral,
        async validate() {

            // const currentValid = await this.tabRefs[this.tabIndex].validate()
            return true
        },
        load() {

            if (this.pacienteId) {

                this.fetch(this.repositories.dispensacao.create, this.pacienteId, this.filaId)
                    .then(({ data }) => {

                        this.setShowDetails(data.form.receitasHistorico)
                        this.setShowDetails(data.form.receitasPendentes)

                        this.additionals = data.additionals
                        this.form = this.clone(data.form)
                        this.model = this.clone(data.model)


                        this.model.item.dispensadoEm = moment(this.form.dataAtual, 'DD/MM/YYYY').toDate()

                        this.model.dataReceita = moment(this.form.dataAtual, 'DD/MM/YYYY').toDate()

                        this.model.medicamentoNaoPadronizado.dataReceita = this.model.medicamentoNaoPadronizado.dataReceita
                            ? this.model.medicamentoNaoPadronizado.dataReceita
                            : moment(this.form.dataAtual, 'DD/MM/YYYY').toDate()

                        if (this.form.receitasPendentes.length > 0) {

                            this.showAlert(
                                'Existe um ou mais itens de receita pendente de entrega!',
                                'Atenção',
                                false,
                                this.handleOpenModalSolicitacoes
                            )
                        }
                        else {

                            this.handleOpenModalSolicitacoes()
                        }

                        this.pacienteObservacao = this.model.paciente.observacao;
                        this.isLoaded = true
                        this.$emit('paciente', this.form.paciente)

                        this.$emit('loaded', {additionals: this.additionals, form: this.form})
                    })
            }
        },
        async handleOpenModalSolicitacoes() {

            await this.$nextTick()

            if (this.form.solicitacoesMedicamentos.length > 0) {

                this.$refs.TabDispensacao.openModalSolicitacoes()
            }
        },
        setShowDetails(receitas){

            receitas.forEach(receita => {

                receita._showDetails = true
            });
        },
        save(justSave = true) {

            this.justSave = justSave

            this.$refs.TabDispensacao.save()
        },
        handleSave() {

            if (!this.hasModelChanged() && this.model.paciente.save === null) {

                if (this.pacienteObservacao == this.model.paciente.observacao) {

                    this.showAlert('Não é possível finalizar, pois nenhuma ação foi realizada.', 'Atenção')
                } else{

                    this.showConfirmation(`Houve uma alteração na observação do paciente, no entanto, não foi adicionado
                        um novo item de dispensação. Deseja continuar?`,
                        async () => {
                            this.model.paciente.save = true
                            this.handleSave()
                        }
                    )
                }
            } else {

                if (this.pacienteObservacao !== this.model.paciente.observacao && this.model.paciente.save === null
                    && this.model.items.length === 0) {

                        this.showConfirmation(`Houve uma alteração na observação do paciente, no entanto, não foi adicionado
                            um novo item de dispensação. Deseja salvar a alteração do campo observação do paciente?`,
                            async () => {
                                this.model.paciente.save = true
                                this.handleSave()
                            },
                            async () => {
                                this.model.paciente.save = false
                                this.handleSave()
                            }
                        )

                        return false
                }

                const params = this.camelObjectKeysToSnakeRecursive(this.clone(this.model))
                params.fila_id = this.filaId

                this.prepareData(params)

                const request = this.model.id
                    ? this.fetch(this.repositories.dispensacao.update, this.model.id, params)
                    : this.fetch(this.repositories.dispensacao.store, params)

                request.then(({ data }) => {
                    if (data.id) {

                        this.showConfirmation("Deseja imprimir o recibo de medicamento?",
                            async () => {

                                this.$nextTick()
                                    .then(() => this.handlePrint(data))
                                    .then(() => this.afterSave())
                            },
                            async () => {

                                this.afterSave()
                            }
                        )
                    }
                    else {

                        this.afterSave()
                    }
                })
            }
        },
        handleDispensar(receita) {

            const dataAtual = moment(this.form.dataAtual, 'DD/MM/YYYY')
            receita.dataReceita = moment(receita.dataReceita, 'DD/MM/YYYY').toDate()

            const hasSomeProximaRetiradaAfterToday = receita.items.some(item => {

                return moment(item.proximaRetirada, 'DD/MM/YYYY').isAfter(dataAtual)
            })

            const fnDispensar = () => {
                receita.items.map(item => {

                    item.proximaRetirada = this.getDateProximaRetirada(item).format('DD/MM/YYYY')
                })

                Object.assign(this.model, receita)
                this.isPendente = true
                this.tabIndex = this.tabRefs.indexOf(this.$refs.TabDispensacao)
            }

            if (hasSomeProximaRetiradaAfterToday) {

                const fnSim = async () => {

                    fnDispensar()
                }

                const fnNao = async () => {

                   receita.items = receita.items.filter(item => {

                        return !moment(item.proximaRetirada, 'DD/MM/YYYY').isAfter(dataAtual)
                    })

                    if (receita.items.length > 0) {

                        fnDispensar()
                    }
                }

                if (this.form.medicamentoSupervisorDispensar) {

                    const confirm = async () => {

                        this.$refs.ModalPermissao.open(receita)
                    }

                    const cancel = async () => { fnNao }

                    const msg = `Um ou mais item da receita selecionada ainda não atingiu a data da próxima retirada,
                        para continuar é necessário informar os dados do supervisor. Deseja continuar?`

                    this.showConfirmation(msg, confirm, cancel)

                    return
                } else {

                    this.showConfirmation(
                        `Um ou mais item da receita selecionada ainda não atingiu a data da próxima retirada,
                        deseja continuar e dispensar esses itens?`,
                        fnSim,
                        fnNao
                    )

                    return
                }
            }

            fnDispensar()
        },
        handleSupervisorDispensar(receita, supervisorId){

            receita.items.map(item => {
                item.proximaRetirada = this.getDateProximaRetirada(item).format('DD/MM/YYYY'),
                item.supervisorId = supervisorId
            })

            Object.assign(this.model, receita)
            this.tabIndex = this.tabRefs.indexOf(this.$refs.TabDispensacao)
        },
        hasModelChanged() {

            const receitasPendentes = this.form.receitasPendentes.some(r => r.items.some(i => i.deleted));
            const receitasHistorico = this.form.receitasHistorico.some(r => r.items.some(i => !i.estornoSalvo && !!i.estornado));
            const medicamentosNaoPadronizados = this.model.medicamentosNaoPadronizados.some(i => i.save || i.deleted);
            const items = this.model.items.length > 0 ? true : false

            return receitasPendentes || receitasHistorico || medicamentosNaoPadronizados || items
        },
        prepareData(params) {

            params.data_receita = params.data_receita ? this.getFormatedDate(params.data_receita, 'YYYY-MM-DD') : null

            params.items = params.items.filter(i => i.entregue > 0)

            params.items.map(item => {

                item.entrada_itens = item.entrada_itens.filter(i => i.quantidade_saida > 0)

                if (!item.dispensado_em) {

                    item.dispensado_em = moment(this.form.dataAtual, 'DD/MM/YYYY').toDate()
                }

                item.dispensado_em = this.getFormatedDate(item.dispensado_em, 'YYYY-MM-DD', 'DD/MM/YYYY')
                item.proxima_retirada = this.getFormatedDate(item.proxima_retirada, 'YYYY-MM-DD', 'DD/MM/YYYY')
                item.material_id = item.material ? item.material.id : null
            })

            params.paciente_id = this.form.paciente.id
            params.cid_id = params.cid ? params.cid.id : null
            params.usuario_id = params.medico_solicitante ? params.medico_solicitante.id : null

            delete params.item
            delete params.cid
            delete params.medico_solicitante
            delete params.medicamento_nao_padronizado

            params.medicamentos_nao_padronizados.map(med => {

                med.data_receita = this.getFormatedDate(med.data_receita, 'YYYY-MM-DD', 'DD/MM/YYYY')
                med.paciente_id = this.form.paciente.id
                med.usuario_id = med.medico_solicitante.id
                med.medicamento_nao_padronizado_id = med.medicamento.id
                med.id = Number.isInteger(med.id) ? med.id : null

                delete med.save
                delete med.medicamento
                delete med.medico_solicitante
            })

            params.receitas_pendentes_deleted = []

            this.form.receitasPendentes.forEach(r => r.items
                .filter(i => i.deleted)
                .forEach(i => params.receitas_pendentes_deleted.push({ id: i.id }))
            )

            params.items_entregas_estornados = []

            this.form.receitasHistorico.forEach(r => r.items
                .filter(i => !i.estornoSalvo && !!i.estornado)
                .forEach(i => params.items_entregas_estornados.push(i.receitaItemEntregaId))
            )

            params.solicitacoes_medicamentos_descartadas = this.form.solicitacoesMedicamentos
                .filter(s => s.descartado)
                .map(s => s.prescricaoId)
        },
        afterSave() {

            this.$nextTick().then(() => {

                let action = async () => {
                    this.unsetShowExitFormConfirmation()
                    if(this.filaId) {
                        this.$router.push({ name: 'farmacia-fila-atendimento-index' })
                    } else {
                        this.$router.push({ name: 'farmacia-dispensacao-index', params: { relatorio: false }})
                    }
                }

                this.showSaveNotification(null, action)
            })
        },
        handlePrint(data) {

            if (data.isRemedioEmCasa) {

                this.imprimirRemedioEmCasa(data.id)

                return
            }

            let medicamentos = this.model.items.map(item => {
                item.entradaItens = item.entradaItens.filter(entrada => entrada.quantidadeSaida > 0);
                return item;
            });

            let agendamento = {
                operadores: Object.values(data.operadores).join(', '),
                medicoNome: this.model.medicoSolicitante.cidadaoNome,
                medicamentos: medicamentos,
                pacienteNome: this.form.paciente.cidadao.nome,
                pacienteNomeSocial: this.form.paciente.cidadao.nomeSocial,
                prontuario: this.form.paciente.prontuario,
                dataNascimento: this.form.paciente.cidadao.dataNascimento.split("-").reverse().join("/"),
                dataAtual: this.form.dataAtual,
                dataEntrega: data.dispensadoEm,
                horaAtendimento: data.horaAtendimento,
                logotipo: this.form.cliente.logotipo,
                nomePrefeitura: this.form.cliente.nome,
                ramoAtividade: this.form.cliente.sistema.ramoAtividade.nome,
                sistemaNome: this.form.cliente.sistema.nome,
                sistemaVersao: this.form.cliente.sistema.versao,
                usuario: this.form.usuario,
                unidade: this.form.unidade,
                telefone: this.form.telefone,
            }

            this.print().dispensacao(agendamento)
        },
        imprimirRemedioEmCasa(receitaId) {

            this.fetch(this.repositories.impressao.receitaRemedioEmCasa, receitaId)
                .then(({ data, headers }) => this.openFile(data, headers['content-type']))
        },
    },
    mounted() {

        this.tabRefs = [
            this.$refs.TabDispensacao,
            this.$refs.TabMedicamentosPendentes,
            this.$refs.TabHistoricoMedicamento,
            this.$refs.TabMedicamentoNaoPadronizado,
        ]
    },
    mixins: [repository, object, error, stringCase, data, request, printFarmacia, file],
    props: {
        filaId: { type: Number, default: null },
        pacienteId: { type: Number, default: null },
    },
}
</script>